import { getBackendInformation } from 'utility/Provide/BackendInformation';

import { BackendInformationInterface } from '../types';

interface BackendInformationWithSentryData extends BackendInformationInterface {
    samplingRate: number;
    replaySplit: string;
}

export const {
    samplingRate,
    replaySplit,
    currentStep,
    activeSplits,
    deviceInformation,
    version,
    currentAgent,
    baseUrl,
    ssoInformation,
    ident,
    route,
} = getBackendInformation<BackendInformationWithSentryData>();
